<template>
    <div>
        <div class="text-center text-title">{{ title }}</div>
        <div style="margin: 0 auto; position: relative;">
            <div class="col-md-10" style="margin: 0 auto; position: relative;">
                <PieChart :data="this.chartdata" :url="''" style="width:100%;"/>
            </div>
        </div>
    </div>
</template>

<script>
import Treasury from '@/components/page/Treasury.js'
//import PieChart from '@/components/chart/Pie.js' //
import PieChart from '@/components/chart/Doughnut.js'
import { Rainbow, Rainbow3, Penanggalan, AppColors, Config, AxiosWithJar } from '@/utility.js'
import { CashPosition } from '@/data/treasury/CashNonCash.js'

export default {
    extends: Treasury,
    components:{ PieChart },
    props: {
        id: {
            type: String,
            default: '',
            //required: false,
        }
    },
    setup() {
        
    },
    mounted() {
        //this.setCashNonCashData()
        this.getData()
    },
    data() {
        return {
            title: 'CASH NON / CASH ' + Penanggalan().tahun,
            chartdata: [],
            loading : {
                table: true,
                chart: true,
            }
        }
    }, 
    methods: {
        async getData() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/v1/treasury/cashnoncash?'

			//this.urlRequestParams+='&date-range-start='+ (this.dateRange && this.dateRange[0] ? this.dateRange[0] : '')
			//this.urlRequestParams+='&date-range-end='+ (this.dateRange && this.dateRange[1] ? this.dateRange[1] : '')
			//this.urlRequestParams+='&tahun='+this.year

			this.loading.table = true;
			this.loading.chart = true;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					let balanceData = response.data.data.data;
					this.title = response.data.data.title.toUpperCase();
                    this.setCashNonCashData(balanceData)
                    //console.log(JSON.stringify(balanceData));
                })
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.chart = false;
					this.loading.table = false;
				})

        },

        setCashNonCashData(data) {
			let item = data //CashPosition;
			//console.log('item pieChartData:' + JSON.stringify(item))
            var warna = []

            let value = [];
            let idx = 0;
            for (var row in item) {
                //add color
                warna[item[row].Label] = AppColors[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].Label, 
                    amount: item[row].Nilai,
                };

                value.push(main);
                idx++;
            }

            this.chartdata = this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
        },
    }
}
</script>

<style>

</style>